import React from "react";
import { Modal } from "antd";
import { RiCloseLine } from "react-icons/ri";

const LabelPopup = props => {
    return (
        <Modal
            title="Label Preview"
            visible={true}
            onCancel={props.handleClose}
            footer={null}
            width="90vw"
            style={{ top: 20 }}
            bodyStyle={{
                padding: '0',
                textAlign: 'center',
                height: '80vh',
                overflow: 'hidden'
            }}
            closeIcon={<RiCloseLine size={24} />}
            destroyOnClose={true}
        >
            {props.content}
        </Modal>
    );
};

export default LabelPopup;